var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSocialYt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.0609 5.19856C34.0609 5.19856 33.7284 2.85469 32.7063 1.82513C31.4111 0.470438 29.9639 0.464062 29.2999 0.384375C24.5452 0.0390623 17.4063 0.0390625 17.4063 0.0390625H17.3935C17.3935 0.0390625 10.2546 0.0390623 5.49988 0.384375C4.83581 0.464062 3.38869 0.470438 2.0935 1.82513C1.07031 2.85469 0.745188 5.19856 0.745188 5.19856C0.745188 5.19856 0.40625 7.94831 0.40625 10.7034V13.2799C0.40625 16.0286 0.745188 18.7847 0.745188 18.7847C0.745188 18.7847 1.07775 21.1286 2.0935 22.1582C3.38869 23.5129 5.08869 23.4661 5.84519 23.6127C8.56838 23.872 17.4063 23.9517 17.4063 23.9517C17.4063 23.9517 24.5516 23.9389 29.3063 23.6C29.9703 23.5203 31.4185 23.5139 32.7126 22.1592C33.7348 21.1297 34.0673 18.7858 34.0673 18.7858C34.0673 18.7858 34.4063 16.0371 34.4063 13.281V10.7044C34.3999 7.95469 34.0609 5.19962 34.0609 5.19962V5.19856ZM13.8873 16.4079V6.85181L23.0715 11.6469L13.8873 16.4079Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialYt);
export default __webpack_public_path__ + "static/media/icon-social-yt.47d7edd828402f8d76dd99bc2312d59a.svg";
export { ForwardRef as ReactComponent };